var map = {
	"./18_PW.png": 11985,
	"./19PW.png": 60318,
	"./20PW.png": 80196,
	"./21PW.png": 50749,
	"components/Catalog/PW/img/glass/ls/lsPlusGold/18_PW.png": 11985,
	"components/Catalog/PW/img/glass/ls/lsPlusGold/19PW.png": 60318,
	"components/Catalog/PW/img/glass/ls/lsPlusGold/20PW.png": 80196,
	"components/Catalog/PW/img/glass/ls/lsPlusGold/21PW.png": 50749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98126;